import React, { useEffect, useState } from "react";
import Modal from "../../Modal";
import { useDispatch } from "react-redux";
import { getQA, replyToQA } from "../../../features/slices/courseDetails";
import { toastService } from "../../../utils/toastify";
import adminPic from "../../../assets/images/admin.png";
const initailState = {
  courseName: "",
  chapterName: "",
  lectureName: "",
  answer: "",
};
const AddQA = ({ handleCloseAddQA, QAData, courseId }) => {
  const [iState, setUpdateState] = useState(initailState);

  const dispatch = useDispatch();

  useEffect(() => {
    setUpdateState({
      ...iState,
      courseName: QAData?.courseData?.title,
      chapterName: QAData?.chapterData?.[0]?.chapterName,
      lectureName: QAData?.lectureData?.[0]?.lectureName,
      answer: QAData?.answer,
    });
  }, [QAData]);

  const { courseName, chapterName, lectureName, answer } = iState;

  const handleChange = (e) => {
    setUpdateState((prev) => ({
      ...prev,
      answer: e.target.value,
    }));
  };

  const handleReply = () => {
    const data = {
      qaId: QAData?._id,
      answer,
    };
    dispatch(replyToQA(data)).then((res) => {
      if (res?.payload?.code == 200) {
        toastService.success("Reply sent successfully");
        setUpdateState((prev) => ({
          ...prev,
          answer: "",
        }));
        dispatch(getQA({ courseId }));
        handleCloseAddQA();
      } else {
        toastService.error("Reply sent failed");
      }
    });
  };

  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={handleCloseAddQA}>
            ×
          </a>
          <h3>Q&amp;A</h3>

          <figure className="d-flex align-items-center justify-content-start">
            <img
              src={QAData?.userData?.profilePic || adminPic}
              style={{ width: "64px", borderRadius: "50%", height: "64px" }}
            />
            <figcaption className="ml-3">
              <h6>{QAData?.userData?.fullName}</h6>
            </figcaption>
          </figure>
          <div className="form-group">
            <label>Course Name :</label>
            <input
              type="text"
              className="form-control"
              placeholder="Course Name (Auto-fill)"
              value={courseName}
              disabled
            />
          </div>
          <div className="form-group">
            <label>Chapter Name :</label>
            <input
              type="text"
              className="form-control"
              placeholder="Chapter Name (Auto-fill)"
              value={chapterName}
              disabled
            />
          </div>
          <div className="form-group">
            <label>Lecture Name :</label>
            <input
              type="text"
              className="form-control"
              placeholder="Lecture Name (Auto-fill)"
              value={lectureName}
              disabled
            />
          </div>
          <div className="form-group">
            <label>Answer :</label>
            <input
              type="text"
              className="form-control"
              placeholder="Write Reply"
              name="answer"
              value={answer}
              onChange={handleChange}
            />
          </div>
          <button className="Button" onClick={handleReply}>
            Post
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AddQA;
